import React, { useState } from 'react';
import { FiLogOut, FiX } from 'react-icons/fi';
import './LogoutConfirmModal.css';

function LogoutConfirmModal({ onConfirm, onCancel }) {
  const [loggingOut, setLoggingOut] = useState(false);

  const handleConfirm = async () => {
    setLoggingOut(true);
    await onConfirm();
  };

  return (
    <div className="logout-modal-overlay" onClick={loggingOut ? undefined : onCancel}>
      <div className="logout-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="logout-modal-close" onClick={onCancel} disabled={loggingOut}>
          <FiX />
        </button>

        <div className="logout-modal-icon">
          <FiLogOut />
        </div>

        <h2>Log out?</h2>
        <p>Are you sure you want to log out of your account?</p>

        <div className="logout-modal-actions">
          <button className="logout-modal-cancel-btn" onClick={onCancel} disabled={loggingOut}>
            Cancel
          </button>
          <button className="logout-modal-confirm-btn" onClick={handleConfirm} disabled={loggingOut}>
            {loggingOut ? <span className="logout-modal-spinner" /> : 'Logout'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default LogoutConfirmModal;
